<template>
  <div id="appointment" class="why-choose-wrap style1 ptb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <!-- Formular programare -->
        <div class="col-lg-6" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="200">
          <div class="book-appointment style1 bg-f">
            <div class="overlay bg-prussian op-95"></div>
           <br/>
            <h5>Programează-te telefonic la numărul de telefon <a href="tel:0753704812" class="style-red">+40 753 704
                812</a> </h5>

            <form action="#" style="    height: 406px;">

            </form>
            <!-- <form action="#">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <input type="text" placeholder="Nume și prenume" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <input type="text" placeholder="Adresă de email" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <input type="number" placeholder="Număr de telefon" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Data programării"
                      onfocus="(this.type='date')"
                      onblur="(this.type='text')"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <select name="dept" id="dept">
                      <option data-display="Alege specialitatea" value="0">
                        Specialitate
                      </option>
                      <option value="1">Psihologie</option>
                      <option value="2">Psihiatrie</option>
                      <option value="3">Neurologie</option>
                      <option value="4">Cardiologie</option>
                      <option value="5">Nutriție & Diabetologie</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <select name="doc" id="doc">
                      <option data-display="Alege medicul" value="0">
                        Medic
                      </option>
                      <option value="1">Dr. Eduard Cocea</option>
                      <option value="2">Dr. Raluca Roman</option>
                      <option value="2">Maria Ciocan</option>
                      <option value="2">Dr. Gina Neculăeş</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <select name="location" id="location">
                      <option data-display="Alege locația" value="0">
                        Locație
                      </option>
                      <option value="Sediu">Pozitiv Medical – Negrești ( VS )  </option>
                      <option value="Telemedicina">Telemedicina</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <textarea
                      name="msg"
                      id="msg"
                      cols="30"
                      rows="10"
                      placeholder="Mesaj (opțional)"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn style2">
                    Trimite solicitarea
                  </button>
                </div>
              </div>
            </form> -->
          </div>
        </div>

        <!-- De ce Pozitiv Medical -->
        <div class="col-lg-6" data-aos="fade-left" data-aos-duration="1200" data-aos-delay="200">
          <div class="wh-content">
            <div class="content-title style1">
              <span class="custom-banner-subtitle">De ce Pozitiv Medical</span>
              <h2>O abordare completă pentru sănătatea ta</h2>
              <p>
                La Pozitiv Medical, credem că sănătatea înseamnă echilibru între
                minte și corp. De aceea, oferim servicii medicale integrate,
                adaptate nevoilor fiecărui pacient.
              </p>
              <p>
                Fie că ai nevoie de evaluare, tratament sau prevenție, echipa
                noastră de specialiști lucrează împreună pentru a-ți oferi
                soluții clare, sigure și personalizate.
              </p>
            </div>
            <ul class="content-feature-list style4 list-style mb-0">
              <li>
                <span><i class="ri-check-double-line"></i></span>
                Echipă medicală multidisciplinară
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>
                Abordare empatică, centrată pe pacient
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>
                Diagnostic corect și planuri de tratament personalizate
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>
                Servicii moderne, într-un mediu sigur și profesionist
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>
                Accent pe prevenție și calitatea vieții
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhyChooseUs",
};
</script>
